import { useRef, useState } from "react";
import { ImagePlus, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { fileUrl } from "@/lib/products";

export const LogoUploader = ({ logoUrl, onSave, testIdPrefix = "logo", label = "Upload logo" }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Please choose an image file"); return; }
    if (file.size > 5 * 1024 * 1024) { toast.error("Logo must be under 5 MB"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/api/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await onSave(data.url);
      toast.success("Logo saved");
    } catch (err) { toast.error(err.response?.data?.detail || "Upload failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-3" data-testid={`${testIdPrefix}-uploader`}>
      <div className="w-16 h-16 rounded-xl border border-dashed border-slate-300 bg-white flex items-center justify-center overflow-hidden shrink-0">
        {logoUrl ? <img src={fileUrl(logoUrl)} alt="Logo" className="max-w-full max-h-full object-contain" data-testid={`${testIdPrefix}-preview`} /> : <ImagePlus className="w-6 h-6 text-slate-300" />}
      </div>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" className="hidden" onChange={handleFile} data-testid={`${testIdPrefix}-file-input`} />
      <div className="flex flex-col gap-1">
        <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} className="text-sm font-medium text-blue-600 hover:text-blue-500 flex items-center gap-1.5 disabled:opacity-50" data-testid={`${testIdPrefix}-upload-btn`}>
          {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />}{logoUrl ? "Change logo" : label}
        </button>
        {logoUrl && <button type="button" onClick={() => onSave("")} className="text-xs text-slate-400 hover:text-red-500 flex items-center gap-1" data-testid={`${testIdPrefix}-remove-btn`}><Trash2 className="w-3 h-3" />Remove</button>}
      </div>
    </div>
  );
};
